export const FooterMenu = {
  Impressum: "/Impressum",
  Datenschutz: "/Datenschutz",
};
